export default function PortfolioReport({
  title,
  subtitle,
  periodLabel,
  categoryLabel,
  rows = [],
  groups = [],
  groupBy = "none",
  tableColumns = [],
  issuedBy = "",
  issuedRole = "",
  generatedAt = "",
  emptyMessage = "No report records matched the selected filters.",
  getFooterValues,
}) {
  return (
    <div className="report-paper bg-white p-4 p-md-5 border" style={paperStyle}>
      <div className="text-center border-bottom pb-3 mb-4" style={{ borderColor: "#cbd5e1" }}>
        <h4 className="mb-1 fw-bold" style={{ color: "#0f172a", letterSpacing: "0.4px" }}>BOB MAPIKIPIKI</h4>
        <h5 className="mb-1" style={{ color: "#1e293b" }}>{title}</h5>
        <div className="small text-muted">
          <span>Period: {periodLabel}</span>
          <span className="mx-2">|</span>
          <span>Generated: {generatedAt}</span>
        </div>
      </div>

      {groupBy === "officer" || groupBy === "model" || groupBy === "customer" ? (
        <div>
          {groups.length > 0 ? (
            groups.map((group) => (
              <div key={group.name} className="mb-4">
                <div className="d-flex justify-content-between align-items-end gap-3 border-bottom pb-2 mb-3">
                  <div>
                    <h6 className="mb-1">{group.displayName || group.name}</h6>
                    <small className="text-muted">{group.records.length} record(s)</small>
                    {Array.isArray(group.details) && group.details.length > 0 ? (
                      <div className="small text-muted mt-1">
                        {group.details.map((detail) => (
                          <div key={detail}>{detail}</div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  <strong style={{ color: "#0f172a" }}>Total Balance: {formatNumber(group.totalAmount)}</strong>
                </div>
                <DetailTable rows={group.records} tableColumns={tableColumns} getFooterValues={getFooterValues} emptyMessage={emptyMessage} />
              </div>
            ))
          ) : (
            <div className="text-center py-4 text-muted">{emptyMessage}</div>
          )}
        </div>
      ) : (
        <DetailTable rows={rows} tableColumns={tableColumns} getFooterValues={getFooterValues} emptyMessage={emptyMessage} />
      )}

      <div className="pt-4 mt-4 border-top" style={{ borderColor: "#cbd5e1" }}>
        <div className="row">
          <div className="col-md-6">
            <div className="small text-muted mb-2">Issued by</div>
            <div className="fw-semibold" style={{ color: "#0f172a" }}>{issuedBy || "System"}</div>
            <div className="text-muted small">{issuedRole || "Report Officer"}</div>
          </div>
          
        </div>
      </div>
    </div>
  );
}

function DetailTable({ rows, tableColumns, getFooterValues, emptyMessage }) {
  const footerValues = getFooterValues ? getFooterValues(rows) : null;

  return (
    <div className="report-table-wrap table-responsive rounded-3 overflow-hidden" style={{ border: "1px solid #dbe2ea" }}>
      <table className="report-table table table-sm align-middle mb-0">
        <thead style={{ backgroundColor: "#f8fafc" }}>
          <tr>
            {tableColumns.map((column) => (
              <th key={column.key} className={column.align === "end" ? "text-end" : ""} style={headCellStyle}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((row, index) => (
              <tr key={row.uuid || `${row.model || row.fullname || "row"}-${index}`}>
                {tableColumns.map((column) => (
                  <td
                    key={`${column.key}-${row.uuid || index}`}
                    className={column.align === "end" ? "text-end" : ""}
                    style={bodyCellStyle}
                  >
                    {renderCell(row[column.key], column)}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={tableColumns.length} className="text-center py-4">
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
        {rows.length > 0 && footerValues ? (
          <tfoot style={{ backgroundColor: "#f8fafc" }}>
            <tr>
              {footerValues.map((item, index) => (
                <th
                  key={`${item}-${index}`}
                  className={index >= footerValues.length - 1 ? "text-end" : ""}
                  style={footCellStyle}
                >
                  {item}
                </th>
              ))}
            </tr>
          </tfoot>
        ) : null}
      </table>
    </div>
  );
}

function renderCell(value, column) {
  if (column.type === "money") {
    return formatNumber(value || 0);
  }

  return value || "";
}

function formatNumber(value) {
  const amount = Number(value || 0);
  return amount.toLocaleString();
}

const paperStyle = {
  borderColor: "#cbd5e1",
  boxShadow: "0 12px 30px rgba(15, 23, 42, 0.05)",
};

const headCellStyle = {
  borderBottom: "1px solid #dbe2ea",
  color: "#475569",
  fontSize: "0.72rem",
  fontWeight: 700,
  letterSpacing: "0.06em",
  padding: "0.7rem 0.65rem",
  textTransform: "uppercase",
  whiteSpace: "normal",
  lineHeight: 1.2,
};

const bodyCellStyle = {
  borderBottom: "1px solid #eef2f7",
  color: "#0f172a",
  padding: "0.68rem 0.65rem",
  verticalAlign: "middle",
  fontSize: "0.88rem",
  lineHeight: 1.35,
  whiteSpace: "normal",
  overflowWrap: "anywhere",
};

const footCellStyle = {
  borderTop: "1px solid #dbe2ea",
  color: "#0f172a",
  fontWeight: 700,
  padding: "0.75rem 0.65rem",
  fontSize: "0.88rem",
};
